<template>
  <b-modal
    title="Create Location"
    header-bg-variant="success"
    header-text-variant="light"
    size="lg"
    :visible="showModal"
    centered
    @hidden="reset">
    <b-form>

    <b-row>
      <h2 v-show="createLocationPending" class="u-padding-bottom-20">Updating, please wait ...</h2>
      <pulse-loader :loading="createLocationPending" color="#489AAC" size="20px"></pulse-loader>
    </b-row>
    <b-form-group
      label="Location Name"
      label-for="title">
        <b-form-input data-vv-name="title" v-validate="'required'" data-vv-as="Title" id="title" size="lg" type='text' name="title" v-model="title"></b-form-input>
        <span v-show="inputValidationErrors.has('title')" class="text-info">{{ inputValidationErrors.first('title') }}</span>
    </b-form-group>

    <b-form-group v-if="isNewOrg">
      <b-form-checkbox
        v-model="isDefault">
        Set as default
      </b-form-checkbox>
    </b-form-group>

   <b-row>
      <b-col>
          <b-form-group
            label-cols-sm="3"
            label="Street:"
            label-align-sm="left"
            label-for="nested-street"
          >
            <b-form-input data-vv-name="addressStreet" v-validate="'required'" data-vv-as="Street" id="nested-street" v-model="addressStreet"></b-form-input>
            <span v-show="inputValidationErrors.has('addressStreet')" class="text-info">{{ inputValidationErrors.first('addressStreet') }}</span>
          </b-form-group>

          <b-form-group
            label-cols-sm="3"
            label="City:"
            label-align-sm="left"
            label-for="nested-city"
          >
            <b-form-input data-vv-name="addressCity" v-validate="'required'" data-vv-as="City" id="nested-city" v-model="addressCity"></b-form-input>
            <span v-show="inputValidationErrors.has('addressCity')" class="text-info">{{ inputValidationErrors.first('addressCity') }}</span>
         </b-form-group>

          <b-form-group
            label-cols-sm="3"
            label="County / Parish:"
            label-align-sm="left"
            label-for="nested-county">
            <b-form-select
              id="nested-country"
              v-validate="'required'"
              data-vv-name="addressCounty"
              data-vv-as="County"
              :options="countyOrParishOptions"
              v-model="addressCounty">
            </b-form-select>
            <span v-show="inputValidationErrors.has('addressCounty')" class="text-info">{{ inputValidationErrors.first('addressCounty') }}</span>

            <b-form-checkbox
              style='margin-left: 20'
              id="cityHall"
              name="cityHall"
              v-model="isCityHall"
              @change="updateCityHall">
                City Hall
              </b-form-checkbox>
          </b-form-group>

          <b-form-group
            label-cols-sm="3"
            label="State:"
            label-align-sm="left"
            label-for="nested-state"
          >
            <b-form-select
              id="nested-state"
              :options="mailingStateOptions()"
              data-vv-name="addressState"
              v-validate="'required'"
              data-vv-as="State"
              v-model="addressState">
            </b-form-select>
            <span v-show="inputValidationErrors.has('addressState')" class="text-info">{{ inputValidationErrors.first('addressState') }}</span>
          </b-form-group>

          <b-form-group
            label-cols-sm="3"
            label="Zip:"
            label-align-sm="left"
            label-for="nested-zip"
          >
            <b-form-input data-vv-name="addressZip" v-validate="'required'" data-vv-as="Zip" id="nested-zip" v-model="addressZip"></b-form-input>
            <span v-show="inputValidationErrors.has('addressZip')" class="text-info">{{ inputValidationErrors.first('addressZip') }}</span>
        </b-form-group>
        <!-- </b-form-group> -->
      </b-col>
      <b-col>
        <b-form-group
            label-cols-sm="3"
            label="Latitude:"
            label-align-sm="left"
            label-for="nested-lat"
          >
            <b-form-input data-vv-name="latitude" v-validate="'required|between:25.831064,49.400387'" data-vv-as="Latitude" id="nested-lat" v-model="latitude"></b-form-input>
            <span v-show="inputValidationErrors.has('latitude')" class="text-info">{{ inputValidationErrors.first('latitude') }}</span>
        </b-form-group>
        <b-form-group
            label-cols-sm="3"
            label="Longitude:"
            label-align-sm="left"
            label-for="nested-long"
          >
            <b-form-input data-vv-name="longitude" v-validate="'required|between:-66.947582,-124.735538'" data-vv-as="Longitude" id="nested-long" v-model="longitude"></b-form-input>
            <span v-show="inputValidationErrors.has('longitude')" class="text-info">{{ inputValidationErrors.first('longitude') }}</span>
         </b-form-group>
        <p><a href="https://www.wikihow.com/Get-Latitude-and-Longitude-from-Google-Maps" target="_blank">Click Here</a> for help identifying latitude and longitude for your location.</p>
      </b-col>
    </b-row>
    <b-alert
      :show="!uniqueLocationName"
      variant="warning"
      >
      <span>Please enter a unique Location name.</span>
    </b-alert>

    </b-form>

    <b-alert
      fade
      :show="createLocationFailure || _.isObject(createLocationSuccess) || (isNewOrg && didSubmitNewLocation)"
      :variant="createLocationFailure ? 'danger' : 'success'">
      <span v-html="apiResponseMessage()"></span>
    </b-alert>

    <div slot="modal-footer" class="w-100">
      <b-button type="button" variant="outline-primary" size="sm" class="float-right" @click="locationHandler">
        <span class="button-text">Create</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'
  let texasData = require('../../store/data/cityHallTX.json')
  let louisianaData = require('../../store/data/cityHallLA.json')

  export default {
    name: 'create-location-modal',
    props: {
      organizationId: Number,
      orgLocations: Array,
      showModal: Boolean,
      isNewOrg: {
        type: Boolean,
        default: () => {
          return false
        }
      }
    },
    data: function () {
      return {
        uniqueLocationName: true,
        title: null,
        addressStreet: null,
        addressCity: null,
        addressCounty: null,
        addressState: null,
        addressZip: null,
        latitude: 30.272722,
        longitude: -97.741062,
        newLocation: {},
        isDefault: false,
        isCityHall: false,
        didSubmitNewLocation: false
      }
    },
    watch: {
      createLocationSuccess: function (newValue) {
        if (this.showModal) {
          _.delay(this.clearForm, 1000)
          _.delay(this.reset, 1100)
        }
      },

      addressCounty (newValue) {
        if (newValue && this.addressState && this.isCityHall) {
          this.updateCityHall(this.isCityHall)
        }
      },

      addressState (newValue) {
        if (newValue && this.addressCounty && this.isCityHall) {
          this.updateCityHall(this.isCityHall)
        }
      }
    },
    computed: {
      // Create a computed property that looks at userContextOrganizationGroups and filters out Groups as a result of orgs that are not the records owningOrg
      // Do you have org admin rights for the owningOrg for this record
      ...mapGetters({
        createLocationPending: 'getCreateLocationPending',
        createLocationSuccess: 'getCreateLocationSuccess',
        createLocationFailure: 'getCreateLocationFailure',
        newLocationDefault: 'getCreateLocation',
        stateAndAbbrev: 'getStateAndAbbrev',
        countyOptions: 'getCountyData',
        parishOptions: 'getLAParishData'
      }),
      countyOrParishOptions () {
        switch (this.addressState) {
          case 'Texas':
            return this.countyOptions
          case 'Louisiana':
            return this.parishOptions
          default:
            this.addressCounty = ' '
            return []
        }
      },
      checkIfRequired () {
        switch (this.addressState) {
          case 'Texas':
          case 'Louisiana':
            return 'required'
          default:
            return ''
        }
      }
    },
    methods: {
      reset: function () {
        this.$emit('update:showModal', false)
        this.clearForm()
      },
      updateCityHall (change) {
        const isTexas = this.addressState === 'Texas'
        const isLouisiana = this.addressState === 'Louisiana'

        if (!change || (!isTexas && !isLouisiana)) {
          return
        }

        const cityHall = isTexas
          ? texasData.filter((item) => (item.County + ' County') === this.addressCounty)[0]
          : louisianaData.filter((item) => (item.Parish) === this.addressCounty)[0]

        if (!cityHall) {
          return
        }

        const cityAttr = isTexas ? 'City Name (county seat)' : 'City Name (parish seat)'
        this.addressCity = cityHall[cityAttr]
        this.addressStreet = cityHall['Full City Hall Address']
        this.addressZip = cityHall['Zip']
        this.latitude = cityHall['Lat Coordinates']
        this.longitude = cityHall['Long Coordinates']
      },
      updateStateAbbr () {
        this.addressState = _.result(_.find(this.stateAndAbbrev, obj => {
          return obj.text === this.organization.mailingState
        }), 'value')
      },
      mailingStateOptions () {
        return _.sortBy(this.stateAndAbbrev, 'Text').map((state) => {
          return {value: state.text, text: state.text}
        })
      },
      locationHandler: function () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.uniqueLocationName = true

            if (this.title) {
              let titleLC = this.title.toLowerCase()
              let orgTitles = this.orgLocations.map((o) => o.title)
              orgTitles.forEach(function (orgTitle) {
                if (orgTitle.toLowerCase() === titleLC) {
                  this.uniqueLocationName = false
                }
              })
            } else {
              this.uniqueLocationName = false
            }

            // Hack way - not sure why reactivity isn't working!!
            this.$forceUpdate()

            if (this.uniqueLocationName) {
              let locationObj = {
                title: this.title,
                addressStreet: this.addressStreet,
                addressCity: this.addressCity,
                addressCounty: this.addressCounty,
                addressState: this.addressState,
                addressZip: this.addressZip,
                latitude: this.latitude,
                longitude: this.longitude
              }
              if (this.isNewOrg) {
                this.newLocation = Object.assign(locationObj, {
                  isDefault: this.isDefault
                })
                this.didSubmitNewLocation = true
              } else {
                if (this.organizationId) {
                  this.$store.dispatch('createLocation',
                    Object.assign(locationObj, {
                      organization: this.organizationId
                    })
                  )
                }
              }
            }
          }
        })
      },
      apiResponseMessage: function () {
        let message = ''
        if (this.isNewOrg && this.didSubmitNewLocation) {
          message = 'Success!'
          if (this.showModal) {
            this.$emit('updateNewLocation', this.newLocation)
            this.newLocation = null
            this.didSubmitNewLocation = null
            this.isDefault = null
            _.delay(this.reset, 1100)
            _.delay(this.clearForm, 1000)
          }
          return '<p>' + message + '</p>'
        }
        if (this.createLocationSuccess) {
          message = 'Success!'

          this.$store.dispatch('getOrganizationView', {
            id: this.organizationId
          })
        }

        if (this.createLocationFailure) {
          message = this.$utils.errorToHtml(this.createLocationFailure)
        }

        return '<p>' + message + '</p>'
      },
      clearForm () {
        this.$store.commit('RESET_CREATE_LOCATION')
        this.organizationId = null
        this.title = null
        this.addressStreet = ''
        this.addressCity = ''
        this.addressCounty = ''
        this.addressState = ''
        this.addressZip = ''
        this.latitude = ''
        this.longitude = ''
        this.isCityHall = false
      }
    },
    beforeDestroy () {
      this.reset()
    },
    created () {
      this.$store.dispatch('getLocationRecords', {})
      const isBetween = (value, { min, max } = {}) => {
        return Math.abs(Number(min)) <= Math.abs(value) && Math.abs(Number(max)) >= Math.abs(value)
      }

      // The first param is called 'min', and the second is called 'max'.
      const paramNames = ['min', 'max']

      this.$validator.extend('between', isBetween, {
        paramNames //  pass it in the extend options.
      })
    }
  }
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Admin/CreateLocationModal.vue